<div role="alert" aria-live="assertive" aria-atomic="true" data-autohide="false">
  <div class="toast-header">
    <img _ngcontent-wtx-c240="" src="assets/style-sauvage_only_logo-removebg.png" height="40px">
    <strong class="mr-auto">Ooops !!</strong>
    <small>{{_data.title | translate}}</small>
    <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="toast-body">
    {{_data.message}}
  </div>
</div>
